import { cn } from '@lcsc-ui/lib/utils';
import { Popover, message } from 'antd';

export default function CopyText({
  tagName: TagName = 'span',
  innerText,
  copyText,
  title,
  className,
  isSingleLine = true,
  isHover = true,
}) {
  const clickCopyText = () => {
    const textarea = document.createElement('textarea');
    textarea.setAttribute('readonly', 'readonly');
    textarea.value = copyText || innerText;
    document.body.appendChild(textarea);
    textarea.select();
    if (document.execCommand('copy')) {
      document.execCommand('copy');
      message.success('复制成功');
    }
    document.body.removeChild(textarea);
  };
  return (
    <>
      {isHover ? (
        <Popover
          content={
            <button className="hover:text-[#199FE9]" size="mini" onClick={clickCopyText}>
              单击复制
            </button>
          }
          placement="right"
          trigger="hover"
        >
          <TagName
            title={title}
            onClick={clickCopyText}
            className={cn(
              'ml-[30px] cursor-pointer text-[#000000] max-w-[350px]',
              isSingleLine && 'lc-text-hidden',
              className
            )}
          >
            {innerText}
          </TagName>
        </Popover>
      ) : (
        <TagName className={className} title={title} onClick={clickCopyText}>
          {innerText}
        </TagName>
      )}
    </>
  );
}
